import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";

function TeachingCenter() {
  const { t } = useTranslation();

  let title = {
    caption: t("pages.teaching_center.title"),
  };

  return (
    <MainLayout title={title}>
      <Page title={t("pages.teaching_center.title")} titleKey="pages.teaching_center.title" isWidthSmall={true}>
        <div data-key="pages.teaching_center.text" dangerouslySetInnerHTML={{ __html: t("pages.teaching_center.text") }}></div>
      </Page>
    </MainLayout>
  );
}

export default TeachingCenter;
